import { Buyer, IBuyer } from './buyer';
export interface User  {
    id: string
    userName: string
}

export interface PageAccessByMenu {
  menuId: number
  menuName: string
  read: boolean
  create: boolean
  update: boolean
  delete: boolean
  special1: boolean
  special2: boolean
  special3: boolean
  special4: boolean
  special5: boolean
  path?: string
}
export interface Auth {
    isLogin: boolean;
    isVerified: boolean,
    twoFactorVerified: boolean
    email: string
    roles?: UserRole[]
    pageAccess?: PageAccessByMenu[]
}

export interface IUserRole  extends UserRoleInformation{
  
}
export enum UserRole {
    FartoyKjoperLandingsted = "Fartøy/Kjøper/Landingsted",
    WebserviceUser = "WebserviceUser",
    Admin = "Admin",
    Leppefiskere = "Leppefiskere",
    RederFartoyeier = "Reder-fartøyeier",
    Kystfisk = "Kystfisk",
    FartoyKjoper = "Fartøy/Kjøper",
    Fartoy = "Fartøy",
    Fiskeridirektoratet = "Fiskeridirektoratet",
    PassiveKjopere = "PassiveKjøpere",
    Kystvakt = "Kystvakt",
    Kjoper = "Kjøper",
    AndreSalgslag = "AndreSalgslag",
    Landingssted = "Landingssted",
    Mattilsynet = "Mattilsynet",
    SUROFI = "SUROFI",
    PassiveBrukere = "PassiveBrukere",
    KystfiskerKjoper = "Kystfisker/Kjøper",
    KjoperLandingsted = "Kjøper/Landingsted",
    Firmaadministrator = "Firmaadministrator"
}



export interface AuthenticationResponse {
    user: User
    roles: UserRole[]
}

export enum OrganizationType{
    Buyer = "Buyer",
    Vessel = "Vessel",
    Terminal = "Terminal"
  }
  
 export  interface UserAccessOrganization{
     businessNumber: string
     ledgerAccountNumber?: string
     displayName: string
     buyerName: string
     terminalName: string
     id?: number
     vesselRegistrationNumber:string
     vesselId:string
     type: OrganizationType
  }


  export interface UserRoleInformation {
    name: string
    id: number;
    code: string;
    description: string;
    buyer: boolean;
    terminal: boolean;
    shipping: boolean;
    vessel: boolean;
  }
  
 
  export interface UserProfile {
    terminals: any[];
    email: string;
    firstName: string;
    lastName: string;
    organizationName: string;
    organizationNumber: string;
    organizationId: string;
    BuyerId ?: string;
    mobileNumber: string;
    mobilePrefix: string;
    userGroup: UserRoleInformation[];
    salesConfirmation: 0 | 1 | 2 | 3;
    salesContract: 0 | 1 | 2 | 3;
    invoice: 0 | 1 | 2 | 3;
    twoFactorSendType : TwoFactorSendType;
    notifications: Notification[];
     salesConfirmationMail: boolean;
    salesConfirmationSms: boolean;
    twoFactorSendTypeId: number;
    invoiceMail: boolean;
    invoiceSms: boolean;
    salesContractMail: boolean;
    salesContractSms: boolean;
    Buyer: IBuyer[];
  }
  
  export  interface TwoFactorSendType 
  {
    id: number;
    name: string;
    nameEnglish: string;
  }
  export interface NotificationMethod extends TwoFactorSendType {}

  export interface Notification {
    id: number;
    event: string;
    description: string;
    NotificationMethodId: number;
    NotificationMethod: NotificationMethod;

  }

  
  
export interface UserListItem {
    id?: string | null;
    oldUserId?: number | null;
    initials: string | null;
    firstname: string | null;
    lastname: string | null;
    fullname: string | null;
    email: string | null;
    phoneNumberPrefix: string | null;
    phoneNumber: string | null;
    isSurofiUser?: boolean | null;
    businessRegistrationId: string | null;
    businessName: string | null;
    temporaryBuyerId: string | null;
    temporaryTerminalId: string | null;
    temporaryVesselId?: number | null;
    receiveSalesConfirmation?: number | null;
    receiveSalesContract?: number | null;
    freshCheckedSalesNote?: number | null;
    frozenCheckedSalesNote?: number | null;
    filetCheckedSalesNote?: number | null;
    userCheckedSalesNote?: number | null;
    freshCheckedLandingNote?: number | null;
    frozenCheckedLandingNote?: number | null;
    filetCheckedLandingNote?: number | null;
    userCheckedLandingNote?: number | null;
    pageSize?: number | null;
    lastLoginDate?: Date | null;
    language: string | null;
    hasSignedGdpr?: boolean | null;
    employeeStatus?: number | null;
    signantUsername: string | null;
    isAuctioneer?: boolean | null;
    twoFactorSendTypeId?: number | null;
    twoFactorCode: string | null;
    twoFactorCodeTime?: Date | null;
    twoFactorCodeTries?: number | null;
    lastUpdated?: Date | null;
    lockoutEnabled?: boolean | null;
    lockoutEnd?: Date | null;
    accessFailedCount?: number | null;
    vessels: string | null;
    buyers: string | null;
    terminals: string | null;
    roles: string | null;
};
